import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  AnomalyKindEnum,
  AutomatedAttendanceOptions,
  Session,
  VerificationServiceEnum,
  VerificationStatusEnum
} from 'src/app/queries/generated';

@Component({
  selector: 'lv-session-attendance-status',
  imports: [NgClass, TranslateModule],
  templateUrl: './session-attendance-status.component.html',
  styleUrl: './session-attendance-status.component.scss'
})
export class SessionAttendanceStatusComponent implements OnInit {
  @Input() sessions: Session[];

  absenceCount = 0;
  assistanceCount = 0;

  get attendanceVerificationStatus(): VerificationStatusEnum {
    const attendanceVerifications = this.sessions
      .flatMap((session) => session.verifications)
      .filter((verification) => verification.service === VerificationServiceEnum.Attendance);

    if (attendanceVerifications.some((item) => item.status === VerificationStatusEnum.Failed)) {
      return VerificationStatusEnum.Failed;
    }

    if (attendanceVerifications.every((item) => item.status === VerificationStatusEnum.Passed)) {
      return VerificationStatusEnum.Passed;
    }

    return VerificationStatusEnum.Pending;
  }

  get automatedAttendanceOptions(): AutomatedAttendanceOptions {
    return this.sessions[0].serviceOptions.automatedAttendance;
  }

  get sessionDurationSum(): number {
    const duration = this.sessions.reduce((acc, session) => acc + session.duration, 0);

    return Math.round(duration / 60);
  }

  get minimumTime(): number {
    const { minimumTime } = this.automatedAttendanceOptions;

    return minimumTime;
  }

  get maximumAbsent(): number {
    const { maximumAbsent } = this.automatedAttendanceOptions;

    return maximumAbsent;
  }

  get maximumAssistance(): number {
    const { maximumAssistance } = this.automatedAttendanceOptions;

    return maximumAssistance;
  }

  get minimumTimeEnabled(): boolean {
    return this.minimumTime >= 0;
  }

  get maximumAbsentEnabled(): boolean {
    return this.maximumAbsent >= 0;
  }

  get maximumAssistanceEnabled(): boolean {
    return this.maximumAssistance >= 0;
  }

  get anythingEnabled(): boolean {
    return this.minimumTimeEnabled || this.maximumAbsentEnabled || this.maximumAssistanceEnabled;
  }

  ngOnInit() {
    const anomalies = this.sessions.flatMap((session) => session.anomalies);

    this.absenceCount = anomalies.filter((anomaly) => anomaly.kind === AnomalyKindEnum.Absent).length;
    this.assistanceCount = anomalies.filter((anomaly) => anomaly.kind === AnomalyKindEnum.Assistance).length;
  }
}
